import React from 'react';
import { BoxImage, CTAButton } from './CTAButton';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-75" data-mp="ek69gwxbmiby">
      <h1 className="text-[1.3rem] font-extrabold uppercase leading-[1.08] text-white sm:text-[2.3rem]" data-id="element-76" data-mp="9ktcvkgndww6">
        The Complete Visual Study System for{' '}
        <span className="text-cyan" data-id="element-77" data-mp="4n9zemrrxo5a">Ultrasound Students</span>
      </h1>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-[1.35] text-white/85 sm:text-[0.92rem]" data-id="element-78" data-mp="129qudld1bpnv">
        Stop jumping between textbooks, lecture notes and scattered ultrasound
        images every time you need to understand what you're seeing. Use
        organized visual references, probe-position guides, annotated
        ultrasound examples and comparison tools to understand anatomy,
        recognize patterns and study ultrasound more clearly.
      </p>
      <p className="mt-1 text-[0.74rem] font-extrabold uppercase leading-tight tracking-wide text-gold sm:text-sm" data-id="element-79" data-mp="382fhvvzgliim">
        Scan. Compare. Recognize with confidence.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[330px]" data-id="element-80" data-mp="3j6fvvj9ob1ao" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-81" data-mp="3o73o289n1o6h">
        <CTAButton label="🩻 YES! I WANT THE COMPLETE SYSTEM" data-id="element-82" data-mp="39albailw2w59" />
        <p className="mt-1.5 text-[0.66rem] font-extrabold uppercase tracking-[0.12em] text-white sm:text-xs" data-id="element-83" data-mp="39a378zszjdms">
          GET ULTRASOUND VISUAL ATLAS™ TODAY
        </p>
        <p className="mt-1 text-[0.62rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-84" data-mp="30gzuyuu2t6tq">
          🛡️ 7-Day Money-Back Guarantee <span className="text-gold" data-id="element-85" data-mp="35aud3tu19dqp">•</span> ⚡
          COMPLETE 6-IN-1 SYSTEM
        </p>
      </div>
    </header>;
}